import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { BookSourceDialog } from './BookSourceDialog';

export const GuideReader = () => {
  const [source, setSource] = useState(null);
  const { pathname } = useLocation();
  useEffect(() => { setSource(null); }, [pathname]);
  useEffect(() => {
    const open = (event) => setSource(event.detail);
    window.addEventListener('sabril:open-guide', open);
    return () => window.removeEventListener('sabril:open-guide', open);
  }, []);
  return source ? <BookSourceDialog source={source} onClose={() => setSource(null)} /> : null;
};